import React from 'react';
import SEO from '../components/SEO';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50" data-testid="cookie-policy-page">
      <SEO 
        title="Slapukų politika | WSK Logistikos paslaugos"
        description="Informacija apie slapukų naudojimą WSK Logistikos paslaugų svetainėje ir Jūsų galimybes valdyti slapukų nustatymus."
        keywords="slapukų politika, cookies, slapukų valdymas, privatumas"
      />
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Slapukų politika</h1>
          <p className="text-xl text-blue-100">
            Atnaujinta: {new Date().toLocaleDateString('lt-LT')}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Kas yra slapukai?</h2>
              <p className="text-gray-600 leading-relaxed">
                Slapukai (angl. cookies) – tai maži tekstiniai failai, kuriuos svetainė įrašo į jūsų
                kompiuterį ar mobilųjį įrenginį, kai jūs apsilankote svetainėje. Slapukai padeda svetainei
                atpažinti jūsų įrenginį ir įsiminti informaciją apie jūsų apsilankymą.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Kokius slapukus naudojame</h2>
              
              <div className="space-y-6">
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Būtini slapukai</h3>
                  <p className="text-gray-600">
                    Šie slapukai yra būtini, kad svetainė veiktų tinkamai. Be jų kai kurios svetainės
                    funkcijos gali neveikti. Būtini slapukai nerenka informacijos, kuri galėtų būti
                    naudojama rinkodaros tikslais.
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Funkciniai slapukai</h3>
                  <p className="text-gray-600">
                    Šie slapukai leidžia svetainei įsiminti jūsų pasirinkimus (pvz., kalbą, regioną)
                    ir suteikti patobulintas, labiau personalizuotas funkcijas.
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Analitiniai slapukai</h3>
                  <p className="text-gray-600">
                    Šie slapukai padeda mums suprasti, kaip lankytojai naudojasi svetaine, kokios
                    sritys yra populiariausios ir kaip galime patobulinti svetainę. Visa informacija
                    yra anoniminė.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Kaip valdyti slapukus</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Dauguma interneto naršyklių automatiškai priima slapukus, tačiau paprastai galite pakeisti
                savo naršyklės nustatymus, kad slapukai būtų atmesti. Atmetus slapukus, kai kurios svetainės
                funkcijos gali neveikti tinkamai.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Informacija apie tai, kaip valdyti slapukus populiariausiose naršyklėse:
              </p>
              <ul className="mt-4 space-y-2 text-gray-600">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Google Chrome: Nustatymai → Privatumas ir saugumas → Slapukai
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Mozilla Firefox: Nustatymai → Privatumas ir saugumas → Slapukai
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Safari: Nuostatos → Privatumas → Slapukai
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Microsoft Edge: Nustatymai → Privatumas → Slapukai
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Trečiųjų šalių slapukai</h2>
              <p className="text-gray-600 leading-relaxed">
                Mūsų svetainėje gali būti naudojami trečiųjų šalių slapukai (pvz., Google Analytics),
                kurie padeda mums analizuoti svetainės naudojimą ir gerinti paslaugų kokybę. Šie slapukai
                renka anoniminę informaciją apie jūsų apsilankymus.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Slapukų galiojimo laikas</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Naudojame dviejų tipų slapukus:
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <strong>Seansų slapukai:</strong> Laikini slapukai, kurie ištrinami uždarius naršyklę
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <strong>Nuolatiniai slapukai:</strong> Lieka įrenginyje nustatytą laiką arba kol juos ištrinate
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Politikos pakeitimai</h2>
              <p className="text-gray-600 leading-relaxed">
                Galime atnaujinti šią slapukų politiką. Apie esminius pakeitimus informuosime svetainėje.
                Rekomenduojame reguliariai peržiūrėti šią politiką.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Kontaktai</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Jei turite klausimų apie mūsų slapukų politiką, susisiekite su mumis:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">MB „WSK Logistikos paslaugos"</p>
                <p className="text-gray-700">El. paštas: info@wsklogistika.lt</p>
                <p className="text-gray-700">Telefonas: +370 650 17855</p>
                <p className="text-gray-700">Adresas: Ateities pl. 28 c, LT-52181 Kaunas</p>
              </div>
            </div>

            <div className="pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500 italic">
                Toliau naudodamiesi mūsų svetaine, sutinkate su slapukų naudojimu pagal šią politiką.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;